export const EXPERIMENTS = {
  // conductor
  USE_DISCOUNT_ON_ORDERING_PAGE: 'useDiscountOnOrderingPage',
  ALLOW_MENU_ITEM_SEO_RENDER_TIME: 'allowMenuItemSeoRenderTimeForOLO',
  CHECKOUT_DELIVERY_OPTIONS: 'restaurantsShouldOmitDeliveryTimeSlotForScheduledDeliveryOrders',
};
